import { Redirect, Route, Switch } from "wouter";
import { InitSelectVehicleView } from "./step-1-select-vehicle/init-select-vehicle.view";
import { InitSelectOrderTypeView } from "./step-2-select-order-type/init-select-order-type.view";
import { InitSetOriginExternalAddressView } from "./step-3-set-origin-external-address/init-set-origin-external-address.view";
import { InitSelectDestinationBranchView } from "./step-4-1-select-destination-branch/init-select-destination-branch.view";
import { InitSetDestinationExternalAddressView } from "./step-4-2-set-destination-external-address/init-set-destination-external-address.view";
import { InitSetDetailsView } from "./step-5-set-details/init-set-details.view";

export function InitRoutes() {
  return (
    <Switch>
      <Route path="/select-vehicle" component={InitSelectVehicleView} />
      <Route path="/select-order-type" component={InitSelectOrderTypeView} />
      <Route path="/set-origin-external-address" component={InitSetOriginExternalAddressView} />
      <Route path="/set-destination-external-address" component={InitSetDestinationExternalAddressView} />
      <Route path="/select-destination-branch" component={InitSelectDestinationBranchView} />
      <Route path="/set-details" component={InitSetDetailsView} />
      <Redirect to="/select-vehicle" replace />
    </Switch>
  );
}
